// @flow

import type { PlanTier } from '@zapier/design-system-revenue';

export default (tier: PlanTier): boolean => tier.pricePerTask === 0;
